import Constants from '@/common/constants';
import { getUserRegionsRfIds, getUserRoleId } from '@/common/utils/userProfile';

import Foiv from '../views/Foiv.vue';
import Home from '../views/Home.vue';
import InterfaceSelected from '../views/InterfaceSelected.vue';
import Widgets from '../views/Widgets.vue';
import Zagran from '../views/Zagran.vue';

export const routes = [
  {
    path: '/',
    name: 'home',
    component: Widgets,
    beforeEnter(to, from, next) {
      const role = getUserRoleId();

      switch (role) {
        case Constants.USER_ROLE_ID.foreignEmployeeRole:
          next({ name: 'foreign-office' });
          break;
        case Constants.USER_ROLE_ID.moduleAdministratorVES:
          next({ name: 'DashboardsVES' });
          break;
        case Constants.USER_ROLE_ID.subjectRF: {
          // На бэке защитили запрос с чужим регионом - если регион не входит в доступные, то вылетает авторизация
          const { userRegionRfIds } = getUserRegionsRfIds();
          next({ name: 'RegionDashboardsVES', query: { regionId: userRegionRfIds[0] } });
          break;
        }
        case Constants.USER_ROLE_ID.employeeVED:
          next({ name: 'FTSMonthly' });
          break;
        default:
          next();
      }
    },
  },
  {
    path: '/widgets',
    name: 'Widgets',
    component: Widgets,
  },
  {
    path: '/home',
    name: 'Sekretar',
    component: Home,
  },
  {
    path: '/home/country/:id',
    name: 'InterfaceSelected',
    component: InterfaceSelected,
  },
  {
    path: '/home/zagran/',
    name: 'Zagran',
    component: Zagran,
  },
  {
    path: '/home/foiv/',
    name: 'Foiv',
    component: Foiv,
  },
  {
    path: '/foreign-office/',
    name: 'foreign-office',
    component: () => import('../views/ForeignOffice.vue'),
  },
];
